import apiClient from "./axiosConfig";

// Get purchases list with search and pagination
export const getPurchasesList = async (params = {}) => {
  try {
    const { search = '', page = 1, page_size = 10, batch_id } = params;
    const queryParams = new URLSearchParams();
    
    if (search) queryParams.append('search', search);
    if (page) queryParams.append('page', page);
    if (page_size) queryParams.append('page_size', page_size);
    if (batch_id) queryParams.append('batch_id', batch_id);
    
    const response = await apiClient.get(`/stock-management/purchases/?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching purchases:', error);
    throw error;
  }
};

// Create new purchase
export const createPurchase = async (purchaseData) => {
  try {
    const response = await apiClient.post('/stock-management/purchases/', purchaseData);
    return response.data;
  } catch (error) {
    console.error('Error creating purchase:', error);
    throw error;
  }
};

// Get purchase by tag
export const getPurchaseByTag = async (params) => {
  try {
    const { unique_identifier, batch_id } = params;
    const response = await apiClient.get(
      `/stock-management/purchases/by-tag/?unique_identifier=${unique_identifier}&batch_id=${batch_id}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching purchase by tag:', error);
    throw error;
  }
};

// Create purchase by tag
export const createPurchaseByTag = async (purchaseData) => {
  try {
    const response = await apiClient.post('/stock-management/purchases/by-tag/', purchaseData);
    return response.data;
  } catch (error) {
    console.error('Error creating purchase by tag:', error);
    throw error;
  }
};

// Update purchase by tag (uses PATCH for price updates)
export const updatePurchaseByTag = async (purchaseData) => {
  try {
    const response = await apiClient.patch('/stock-management/purchases/by-tag/', purchaseData);
    return response.data;
  } catch (error) {
    console.error('Error updating purchase by tag:', error);
    throw error;
  }
};

// Update purchase
export const updatePurchase = async (purchaseId, purchaseData) => {
  try {
    const response = await apiClient.patch(`/stock-management/purchases/${purchaseId}/`, purchaseData);
    return response.data;
  } catch (error) {
    console.error('Error updating purchase:', error);
    throw error;
  }
};

// Delete purchase
export const deletePurchase = async (purchaseId) => {
  try {
    const response = await apiClient.delete(`/stock-management/purchases/${purchaseId}/`);
    return response.data;
  } catch (error) {
    console.error('Error deleting purchase:', error);
    throw error;
  }
};
